import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-match-status-badge',
  standalone: true,
  imports: [],
  template: `
    @if (status === 'MATCH') {
      <div class="badge match" title="Potential match found in system">
        <i class="material-symbols-rounded">error_outline</i>
        <span>Match Found</span>
      </div>
    }
    @if (status !== 'MATCH') {
      <div class="badge new" title="New record">
        <i class="material-symbols-rounded">check</i>
        <span>New</span>
      </div>
    }
    `,
  styleUrl: './match-status-badge.component.scss'
})
export class MatchStatusBadgeComponent {
    @Input() status: 'NEW' | 'MATCH' = 'NEW';
}
